<div class="vehicle-status-empty" *ngIf="hasFleetConnected; else noFleetConnected">
  <ng-container *ngIf="hasFleetSelected; else noFleetSelected">
    <ng-container [ngSwitch]="vehicleStatusFilterSelected">
      <ng-container *ngSwitchCase="EVehicleStatusType.Moving">
        <mat-icon svgIcon="ic-no-moving" class="vehicle-status-empty__icon"></mat-icon>
        <p i18n="@@S_NO_MOVING_UNITS_DETECTED" class="vehicle-status-empty__text">No moving units detected</p>
      </ng-container>

      <ng-container *ngSwitchCase="EVehicleStatusType.Idle">
        <mat-icon svgIcon="ic-no-idling" class="vehicle-status-empty__icon"></mat-icon>
        <p i18n="@@S_NO_IDLING_UNITS_DETECTED" class="vehicle-status-empty__text">No idling units detected</p>
      </ng-container>

      <ng-container *ngSwitchCase="EVehicleStatusType.Stopped">
        <mat-icon svgIcon="ic-no-stopped" class="vehicle-status-empty__icon"></mat-icon>
        <p i18n="@@S_NO_STOPPED_UNITS_DETECTED" class="vehicle-status-empty__text">No stopped units detected</p>
      </ng-container>

      <ng-container *ngSwitchCase="EVehicleStatusType.Charging">
        <mat-icon svgIcon="ic-no-charging" class="vehicle-status-empty__icon"></mat-icon>
        <p i18n="@@S_NO_CHARGING_UNITS_DETECTED" class="vehicle-status-empty__text">No charging units detected</p>
      </ng-container>
    </ng-container>

    <ng-container
      *ngIf="[EDeviceErrorType.All, EDeviceErrorType.TrackerError, EDeviceErrorType.CameraError].includes(vehicleStatusFilterSelected)"
    >
      <mat-icon svgIcon="ic-no-device-error" class="vehicle-status-empty__icon"></mat-icon>
      <p i18n="@@S_NO_DEVICE_ERRORS_DETECTED" class="vehicle-status-empty__text">No device errors detected</p>
    </ng-container>
  </ng-container>

  <ng-template #noFleetSelected>
    <ng-container *ngIf="hasAttributeFilter; else noFleet">
      <ng-container *ngIf="hasAttributeError; else noResults">
        <p i18n="@@S_ATTRIBUTE_FILTER_HTTP_ERROR_TITLE" class="vehicle-status-empty__text-bold">Something went wrong</p>
        <p i18n="@@S_ATTRIBUTE_FILTER_HTTP_ERROR_DESCRIPTION" class="vehicle-status-empty__text-regular-weight">Please try again later</p>
        <button
          mat-button
          class="primary"
          i18n="@@S_ATTRIBUTE_CHIPS_BUTTON_REFRESH"
          (click)="retryFilterClick()"
          a7s-id="live-map-selection-panel-attribute-filter-retry"
        >
          REFRESH
        </button>
      </ng-container>
      <ng-template #noResults>
        <p i18n="@@S_VEHICLE_PANEL_LIST_NO_RESULTS_TITLE" class="vehicle-status-empty__text-bold">No results</p>
        <p i18n="@@S_VEHICLE_PANEL_LIST_NO_RESULTS_DESCRIPTION" class="vehicle-status-empty__text-regular-weight">
          Try adjusting your filters.
        </p>
      </ng-template>
    </ng-container>
    <ng-template #noFleet>
      <mat-icon svgIcon="ic-no-fleet-selected" class="vehicle-status-empty__icon"></mat-icon>
      <p i18n="@@S_NOTHING_TO_DISPLAY" class="vehicle-status-empty__text-bold">Nothing to display</p>
      <p i18n="@@S_SELECT_UNITS_TO_START_MONITORING" class="vehicle-status-empty__text-regular-weight">
        Select units from your fleet to start monitoring
      </p>
      <button
        mat-button
        class="btn-uppercase"
        i18n="@@S_SELECT_FLEET_CAPS"
        (click)="selectVehiclesClick()"
        a7s-id="live-map-selection-panel-empty-state-select-vehicles"
      >
        SELECT FLEET
      </button>
    </ng-template>
  </ng-template>
</div>

<ng-template #noFleetConnected>
  <div class="vehicle-status-empty">
    <mat-icon svgIcon="ic-no-fleet-connected" class="vehicle-status-empty__icon"></mat-icon>
    <p i18n="@@S_YOUR_FLEET_NOT_CONNECTED" class="vehicle-status-empty__text-bold">Your fleet isn't connected yet</p>
    <p i18n="@@S_INSTALL_UNIT_TO_CONNECT_FLEET" class="vehicle-status-empty__text-regular-weight">
      Install Verizon Connect units to connect your fleet to Reveal
    </p>
    <a
      href="{{ fleetConnectionHelpUrl }}"
      i18n="@@S_LINK_TO_HELP_ARTICLE"
      class="vehicle-status-empty__text-link"
      a7s-id="live-map-selection-panel-empty-state-help-article-link"
      >How to connect your fleet</a
    >
  </div>
</ng-template>
